import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["disabled", "value"];
import { onMounted, onUnmounted, ref } from "vue";
import { fixValue, maskPhoneInput } from "../maskInputs";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PhoneControl',
    props: /*@__PURE__*/ _mergeModels({
        disabled: Boolean,
        error: String,
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(['valid', 'invalid', 'update:model-value'], ["update:modelValue"]),
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var value = _useModel(__props, "modelValue");
        var input = ref(null);
        var mask = ref(null);
        var emit = __emit;
        onMounted(function () {
            mask.value = maskPhoneInput(input.value);
            mask.value.on('accept', function () {
                emit('update:model-value', input.value.value);
                emit('invalid');
            });
            mask.value.on('complete', function () {
                if (mask.value.value.match(/^8/)) {
                    fixValue(input.value, mask.value);
                    if (input.value.selectionStart) {
                        setTimeout(function () {
                            input.value.selectionEnd++;
                            input.value.selectionStart++;
                        }, 50);
                    }
                }
                else {
                    emit('valid');
                }
            });
        });
        onUnmounted(function () {
            mask.value.off('accept');
            mask.value.off('complete');
            mask.value.destroy();
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("input", {
                type: "tel",
                name: "phone",
                class: "form-control",
                required: "",
                autocomplete: "phone",
                disabled: __props.disabled,
                value: value.value,
                ref_key: "input",
                ref: input,
                placeholder: "+7 (900) 123-45-67"
            }, null, 8 /* PROPS */, _hoisted_1));
        };
    }
});
